import { HighlightBanner } from './HighlightBanner'
import { withHighlightBanner } from './withHighlightBanner'

const ConnectedHighlightBanner = withHighlightBanner(HighlightBanner)
export { ConnectedHighlightBanner as HighlightBanner }
